import { useState } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select';


const SelectField = ({value, name, type, label, validate, valid, valid_reg, disable, options, setFieldValid, setValueSelect, trigger}) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
  
    const labelClick = (ev) => {
        
    }

    const onSelect = (value) => {
        setValueSelect(name, value, true, true)
    }

    return (
        <div 
            className="form__group"
            data-disable={disable}
        >
            <div className={selectedOption || isOpen || value ? "form__label form__label_fixed" : "form__label"}>{label}</div>
            <Select
                className="select"
                classNamePrefix="select"
                placeholder={''}         
                value={value}  
                isSearchable={false}        
                components={{
                    DropdownIndicator: () => null,
                    IndicatorSeparator: () => null,
                }} 
                onMenuOpen={() => setIsOpen(true)}
                onMenuClose={() => setIsOpen(false)}
                defaultValue={null}
                onChange={onSelect}
                options={options}
            />  
        </div>
    )

}

SelectField.propTypes = {
  value: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  valid: PropTypes.bool.isRequired,
  valid_reg: PropTypes.bool.isRequired,
  //options: PropTypes.func.isRequired,
  trigger: PropTypes.bool.isRequired,
}


export default SelectField